import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { getSeriesColors } from '../../dashboardChartColors';

const CHART_HEIGHT = 280;

function DashboardPolarChart({ series = [] }) {
    const labels = series.map((item) => item.label);
    const values = series.map((item) => item.value);
    const colors = getSeriesColors(series);

    const options = {
        chart: {
            type: 'polarArea',
            toolbar: { show: false },
            animations: { enabled: true, easing: 'easeinout', speed: 800 },
        },
        labels,
        colors,
        fill: {
            opacity: 0.85,
        },
        stroke: {
            width: 2,
            colors: ['#fff'],
        },
        yaxis: {
            show: false,
        },
        legend: {
            position: 'bottom',
            horizontalAlign: 'center',
            fontSize: '12px',
            markers: { width: 10, height: 10, radius: 4 },
        },
        plotOptions: {
            polarArea: {
                rings: {
                    strokeWidth: 1,
                    strokeColor: '#e8ecf4',
                },
                spokes: {
                    strokeWidth: 1,
                    connectorColors: '#e8ecf4',
                },
            },
        },
        dataLabels: {
            enabled: true,
            formatter: (val, opts) => {
                const raw = opts.w.config.series[opts.seriesIndex];
                return raw >= 1000 ? `${(raw / 1000).toFixed(1)}k` : Math.round(raw);
            },
            style: { fontSize: '11px', fontWeight: 600, colors: ['#fff'] },
        },
        tooltip: {
            y: { formatter: (val) => val.toLocaleString() },
        },
    };

    return (
        <ReactApexChart
            options={options}
            series={values}
            type="polarArea"
            height={CHART_HEIGHT}
            width="100%"
        />
    );
}

export default DashboardPolarChart;
